import { atom } from 'recoil';
import { IReuniao } from '../../commons/types/crm';

export const reuniaosAtom = atom<IReuniao[]>({
  key: 'reuniaos', 
  default: [] as IReuniao[],
}); 
